import React from 'react';
import image from '../../assets/image.png';
import SocialBar from '../../components/SocialBar';

const About = () => {
  return (
    <div id="About" className="flex w-full h-screen">
      <div className="container m-auto px-6 text-gray-600 md:px-12 xl:px-40">
        <div className="md:5/12 md:w-36 pb-5 w-24">
          <img src={image} alt="image" loading="lazy" />
        </div>
        <div className="space-y-6 md:space-y-0 md:flex md:gap-6 lg:items-center lg:gap-12">
          <div className="md:7/12 lg:w-9/12">
            <h2 className="text-2xl text-gray-800 font-bold md:text-4xl">
              Desarrollador full-stack
            </h2>
            <p className="mt-6 text-gray-600">
              Soy Jacobo García, un desarrollador full-stack con experiencia en
              proyectos como aplicaciones móviles para restaurantes, páginas web
              para promocionar tiendas y aplicaciones web con React.
            </p>
            <p className="mt-4 text-gray-600">
              Me apasiona el desarrollo y disfruto trabajando con Typescript.
              Estoy dispuesto a aplicar mis habilidades y conocimientos para
              ayudar a mis clientes a alcanzar sus objetivos. ¡Estoy ansioso por
              trabajar en su próximo proyecto!
            </p>
          </div>
        </div>
        <SocialBar />
      </div>
    </div>
  );
};

export default About;
